import { bffCrmFeatureAccess } from '@fireflyhealth/api'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'

const getFeatureAccess = () => bffCrmFeatureAccess.retrieve().then(r => r.data)

// Check and cache feature access for the current tenant. Exposes the whole query
// for callers that must tell "this tenant lacks the feature" apart from "the
// answer hasn't arrived yet" — a distinction that decides routing in
// PatientDetailNav.
const useFeatureAccessQuery = () => {
  const me = useSelector(state => state.me)
  return useQuery({
    queryKey: ['featureAccess'],
    queryFn: () => getFeatureAccess(),
    staleTime: 24 * 60 * 60 * 1000, // 1 day
    enabled: !!me?.provider_fields,
  })
}

const useFeatureAccess = () => useFeatureAccessQuery().data

export { useFeatureAccess, useFeatureAccessQuery }
